
export default {
  props: {
    playerPosition: {
      type: Array,
      default: () => [],
    },
    positionFilters: {
      type: Array,
      default: () => [],
    },
    loanPlayers: {
      type: Array,
      default: () => [],
    },
    activeFilter: {
      type: [Array, String],
      default: () => [],
    },
  },
  computed: {
    filters () {
      const filters = [];

      // Add dynamic elements from config to filters array
      this.positionFilters.forEach(filter => {
        filters.push({
          title: filter.filter_display_name,
          value: filter.positions_to_include.split(`,`),
        });
      });

      // Add static elements to array
      filters.unshift({
        title: `All`,
        value: ``,
      });
      filters.push({
        title: `On Loan`,
        value: `onLoan`,
      });
      return filters;
    },
  },
  methods: {
    setFilter (filter) {
      this.$parent.activeFilter = filter;
    },
    getPositionTotal (value) {
      if (value === `onLoan`) {
        return this.loanPlayers.length;
      } else if (value === ``) {
        return 0;
      }
      return this.playerPosition.filter(position => value.includes(position)).length;
    },
  },
};
